export { API, auth, money, fmtDate, errMsg, exportExcel, printArea, PrintStyle, StatusBadge, exportPdf } from '../finance/shared';

const RIYADH_OFFSET_MS = 3 * 60 * 60 * 1000;

export const toRiyadhDateStr = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getTime() + RIYADH_OFFSET_MS).toISOString().slice(0, 10);
};

export const riyadhTodayStr = () => toRiyadhDateStr(new Date());
export const riyadhDaysAgoStr = (days) => toRiyadhDateStr(new Date(Date.now() - days * 86400000));
export const inRange = (value, from, to) => {
  if (!value) return false;
  const d = String(value).slice(0, 10);
  if (from && d < from) return false;
  if (to && d > to) return false;
  return true;
};

export const FINANCE_ROLES = ['admin', 'manager', 'treasurer'];
export const HR_ROLES = ['admin', 'manager', 'treasurer'];
export const MANAGE_ROLES = ['admin', 'manager'];

export const hasRole = (user, roles) => Boolean(user) && (user.is_super_admin || roles.includes(user.role));
